<template>
  <table>
    <!-- table head -->
    <thead>
      <tr>
        <th scope="col" class="text-left pr-6 pb-1">Day</th>
        <th scope="col" class="text-left pb-1">Opening Times</th>
      </tr>
    </thead>

    <tbody class="w-full font-light mt-2.5">
      <tr
        v-for="(openingTime, weekday) of openingTimesInWeekdayOrder"
        :key="weekday"
        :class="{
          'font-medium': weekday === currentDayOfWeek
        }"
      >
        <td class="capitalize pr-6 pb-1 align-text-top">
          {{ weekday }}
        </td>
        <td class="pb-1">
          <div v-if="openingTime.isClosed">Closed</div>
          <div v-else-if="openingTime.open24Hours">Open 24hrs</div>
          <div v-else-if="!openingTime.openingHours.length">Closed</div>
          <div v-else>
            <div v-for="(openingHours, i) in openingTime.openingHours" :key="i" class="inline-block">
              {{ formatMilitaryTime(openingHours.startTime) }} -
              {{ formatMilitaryTime(openingHours.endTime) }}

              <!-- If there are multiple opening times separate them with a comma -->
              <span v-if="i < openingTime.openingHours.length - 1" class="mr-2"> , </span>
            </div>
          </div>
          <span
            v-if="openingTime.hasIrregularHours && openingTime.irregularHoursText"
            class="block text-gray-600 font-light text-sm"
          >
            ({{ openingTime.irregularHoursText }})
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script setup lang="ts">
// Import tooling
import { formatMilitaryTime } from '~/utils/formatMilitaryTime'
import type { OpeningTimes } from '~/types/OpeningTimes'
import type { DaysOfWeek } from '~/types/DaysOfWeek'
import { daysOfWeek } from '~/types/DaysOfWeek'
import { getCurrentDayOfWeek } from '~/utils/openingTimes/getCurrentDayOfWeek'

const props = defineProps({
  openingTimes: {
    type: Object as PropType<OpeningTimes>,
    required: true
  }
})

// Ensure that the opening times are in the correct order
const openingTimesInWeekdayOrder = computed(() => {
  const orderedOpeningTimesArray = Object.entries(props.openingTimes).sort((a, b) => {
    return daysOfWeek.indexOf(a[0] as DaysOfWeek) - daysOfWeek.indexOf(b[0] as DaysOfWeek)
  })
  return Object.fromEntries(orderedOpeningTimesArray)
})

const { currentDayOfWeek } = getCurrentDayOfWeek()
</script>
